import React, { useEffect, createRef } from 'react'
import styled from 'styled-components'
import { makeStyles} from '@material-ui/core/styles'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link';
import ChromeReaderModeIcon from '@material-ui/icons/ChromeReaderMode';
import MicIcon from '@material-ui/icons/Mic';
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import EditIcon from '@material-ui/icons/Edit';
import FlashCardIcon from '@material-ui/icons/FilterNone';
import MentalMapIcon from '@material-ui/icons/AccountTree';
import { NavLink as LinkRouter,  useParams } from 'react-router-dom'
import { secondsConverter } from '../../utils/time'

const useStyles = makeStyles(theme => ({
    lightBackground: {
      backgroundColor: '#F4F3F4',
      color: '#000',
      borderLeft: `4px solid #F4F3F4`,
      '&:hover': {
        textDecoration: 'none',
        cursor: 'pointer'
      },
      '&.active-content': {
          borderLeftColor: `${theme.palette.primary.main}`
      }
    }
}));

const ContentWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`

const ContentItem = styled.div`
    margin: 8px 16px 8px 24px;
    display: flex
`

const TextWrapper = styled.div`
    display: flex;
    flex-direction: column
`

const ContentItemList = ({ content, courseId, onClose }) => {
    const inputEl = createRef();
    const classes = useStyles();
    const { id } = useParams()

    const scroll = () => {
        const scrolling = inputEl?.current?.scrollIntoView({block: "start" ,behavior: 'smooth'})
        if (!scrolling) return false
        if(scrolling) return true
    }

    useEffect(() => {scroll()})

    const contentTypes = {
        leitura: 'Leitura -',
        video: 'Vídeo -',
        quiz: 'Quiz -',
        podcast: 'Podcast -',
        'mapa mental': 'Mapa Mental -',
        'slide de aula': 'Slide de aula -'
    }

    const getTypeText = (tipo, subtipo) => {
        return contentTypes[subtipo || tipo].toUpperCase()
    }

    const getIcon = ({ tipo, subtipo }, concluido = false) => {
        if(concluido) return <CheckCircleIcon style={{ color: 'green' }} />
        if(subtipo) {
            if (subtipo === 'mapa mental') return <MentalMapIcon />
            if (subtipo === 'slide de aula') return <ChromeReaderModeIcon />
            if (subtipo === 'flashcard') return <FlashCardIcon />
        }
        if (tipo === 'leitura') return <ChromeReaderModeIcon />
        if (tipo === 'video') return <PlayCircleOutlineIcon />
        if (tipo === 'quiz') return <EditIcon />
        if (tipo === 'podcast') return <MicIcon />
    }

    const mapLength= (content || []).length

    return (
        <ContentWrapper>
            {(content || []).map((item, key) => {

               if (key === (mapLength - 1)) setTimeout(() => { scroll() }, 1000)
            

            return (
                <>
                    { (courseId === item._id) ? <div ref={inputEl}></div> : false}
                    <Link 
                        key={item._id}
                        component={LinkRouter}
                        onClick={() => onClose && onClose('left')}
                        activeClassName='active-content'
                        exact
                        to={`/curso/${id}/${item._id}`}
                        className={classes.lightBackground}
                    >
                        <ContentItem>
                            {getIcon({ tipo: item.tipo, subtipo: item.subtipo }, item.concluido)}
                            <TextWrapper>
                                <Typography style={{ fontSize: '14px', marginLeft: '10px', wordBreak: 'break-word' }}>
                                    {`${getTypeText(item.tipo, item.subtipo)} ${item.titulo.split('').map(letter => letter === '/' ? ' / ' : letter).join('')}`}
                                </Typography>
                                <Typography style={{ fontSize: '14px', marginLeft: '10px', fontWeight: '300' }}>
                                    {item.tempo > 0 ? `${secondsConverter(item.tempo)}` : ''}
                                    {!!(item || {}).tempo && !!(item || {}).professor && '-'}
                                    {(item|| {}).professor && `Professor(a): ${item.professor}`}
                                </Typography>
                            </TextWrapper>
                        </ContentItem>
                    </Link>
                </>
            )})}
        </ContentWrapper>)}

export default ContentItemList
